import type { useGT } from 'gt-react';
import type { GetAPInvoiceResponse } from '@erp/rpc';

type Translate = ReturnType<typeof useGT>;
type ExtractedTotalWarning = NonNullable<
  GetAPInvoiceResponse['extractedTotalWarning']
>;

const WARNING_CONTEXT =
  'non-blocking note when AP invoice line items do not add up to the extracted document total';

/** Sentences for the amber note under Total Amount. Empty when there is no gap. */
export function extractedTotalWarningMessages(
  warning: ExtractedTotalWarning | null | undefined,
  gt: Translate,
): string[] {
  if (!warning) return [];
  const messages = [
    gt(
      'Line items total {current}. Extracted total {extracted} from the document.',
      {
        context: WARNING_CONTEXT,
        current: warning.currentTotal,
        extracted: warning.extractedTotal,
      },
    ),
  ];
  if (warning.extractionDiffers && warning.extractedLineSum) {
    messages.push(
      gt(
        'The extracted total does not match the extracted line items ({extractedLineSum}).',
        {
          context: WARNING_CONTEXT,
          extractedLineSum: warning.extractedLineSum,
        },
      ),
    );
  }
  if (warning.invoiceUpdated) {
    messages.push(
      gt(
        'The invoice was updated after extraction, and those changes are not in the extracted total.',
        { context: WARNING_CONTEXT },
      ),
    );
  }
  return messages;
}
